import { graphql } from "../generated";

export const UserLicensesQuery = graphql(
  `
    query UserLicenses($userId: String!) {
      userLicenses(userId: $userId) {
        licenses {
          active
          name
        }
      }
    }
  `
);
